import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Modal,
  Row,
} from "react-bootstrap";
import "./enquiry.css";
import { Table } from "antd";
import { IoEyeOutline } from "react-icons/io5";
import PostApiCall from "../../../helpers/PostApi";
import Notiflix from "notiflix";
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import moment from "moment";
import { BsTrash } from "react-icons/bs";
const columns = [
  {
    title: "S. No.",
    dataIndex: "serial",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Mobile Number",
    dataIndex: "mobile",
  },
  {
    title: "Date",
    dataIndex: "date",
  },
];
const Enquiries = () => {
  const [certificates, setCertificates] = useState([]);

  const users = certificates?.map((data, index) => {
    return {
      id: data?.fld_id,
      name: data?.fld_name,
      email: data?.fld_email,
      mobile: data?.fld_mobile,
      serial: index + 1,
      date: data?.fld_createdon
        ? moment(data?.fld_createdon, "MMM  D YYYY hh:mma").format("DD-MM-YYYY")
        : "-",
    };
  });
  useEffect(() => {
    GetEnquiry();
  }, []);
  const GetEnquiry = () => {
    Notiflix.Loading.dots();
    PostApiCall.postRequest(
      {
        whereClause: "",
      },
      "GetEnquiries"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status === 200 || result.status === 201) {
          const fetchedData = obj?.data?.filter(
            (data) => data?.fld_status !== "Deleted"
          );
          setCertificates(fetchedData?.sort((a, b) => b?.fld_id - a?.fld_id));
          Notiflix.Loading.remove();
        } else {
          Notiflix.Loading.remove();
          Notiflix.Notify.failure("");
        }
      })
    );
  };

  return (
    <>
      <section className="certificate-section section-spacing-x">
        <Container fluid>
          <div className="certificate-list">
            <div className="section-bootom-border pb-4 mb-4">
              <h1 className="text-start text-white mb-0">Enquiry List</h1>
            </div>

            <Table
              columns={columns}
              dataSource={users}
              size="larger"
              className="certificate-table d-none d-lg-block w-100"
            />
            <Row className="d-block d-lg-none">
              {users.map((user) => (
                <Col lg={6} key={user?.id} className="mb-3">
                  <Card className="certificateList-card">
                    <CardHeader className="p-3">
                      <h4 className="mb-0">S. No. {user?.serial}</h4>
                    </CardHeader>
                    <CardBody className="p-3">
                      <div className="card-item d-flex gap-2 mb-2">
                        <span className="fw-500">Name -</span>
                        <span>{user?.name}</span>
                      </div>
                      <div className="card-item d-flex gap-2 mb-2">
                        <span className="fw-500">Mobile -</span>
                        <span>+91 {user?.mobile}</span>
                      </div>
                      <div className="card-item d-flex gap-2">
                        <span className="fw-500">Email -</span>
                        <span>{user?.email}</span>
                      </div>
                      <div className="card-item d-flex gap-2">
                        <span className="fw-500">Date -</span>
                        <span>{user?.date}</span>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Enquiries;
